import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useProjectAsk = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [askList, setAskList] = useState<ProjectAskListDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const { isLoading, refetch } = useQuery(
    [endpoints.project.ask.list, location.search],
    () =>
      fetcher.project.postProjectAskList({
        pageNo: Number(searchParams.pageNo) || 1,
        pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
        searchValue: searchParams.search ? String(searchParams.search) : '',  
        searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : '',   
        searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : '',  
        biz: searchParams.biz ? String(searchParams.biz) : '',  
        pm: searchParams.pm ? String(searchParams.pm) : '',  
        status: searchParams.status ? String(searchParams.status) : '',  
        lecture_type: searchParams.lecture_type ? String(searchParams.lecture_type) : '',  
        lecture_subject: searchParams.lecture_subject ? String(searchParams.lecture_subject) : '', 
        order: searchParams.order ? String(searchParams.order) : '',
        reverse: searchParams.reverse ? String(searchParams.reverse) : '',
        company: '',
      }),
    {
      onSuccess: (res: ProjectAskListResDto) => {
        switch (res.code) {
          case 200:
            setAskList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || INIT_PAGESIZE,
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: noteFileUpdate } = useMutation(
    [endpoints.project.ask.note.filesave],
    fetcher.project.postProjectAskNoteFileUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  return { askList, searchResult, refetch, noteFileUpdate };
};

export default useProjectAsk;
